import Backbone from 'backbone'
import _ from 'lodash'
import Files from 'scoreboard/components/files/files'
import Header from 'scoreboard/components/display-header'
import File from 'scoreboard/components/files/file'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import template from './documents-folder-overview.hbs'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import SendToOptions from 'scoreboard/components/send-to-options'
import spotlight from 'scoreboard/components/spotlight'
import FileDropOverlay from 'scoreboard/components/files/file-drop-overlay'
import UploadForm from 'scoreboard/components/files/upload-form'
import config from 'scoreboard/components/config'
import appDisplay from 'scoreboard/components/app-display'
import fileDrop from 'scoreboard/components/files/file-drop.hbs'
import permissions from 'scoreboard/components/permissions'

var FolderOverview = Backbone.View.extend({

	// this.model is a File (of type 'folder')

	className: 'display-layout table-hack documents scroll-layout-xy folder-overview documents-folder-overview',

	events: {
		'dragenter': 'onDragEnter',
		'click .file-drop': 'onFileDropClick'
	},

	initialize: function() {
		this.listenTo(Backbone, 'edit:domain-object', this.editDomainObject)
	},

	render: function() {
		this.removeChildren()

		this.folders = []

		// render header
		this.header = new Header({
			model: this.model,
			subsection: 'overview',
			sendToOptions: SendToOptions.defaultNoExport({section: 'files', type: 'folder'}),
			tabs: tabs({ id: this.model.id, section: 'files', overviewTabCode: 'common.overview' })
		})
		this.header.setupOverviewInfo()
		this.$el.empty().append(this.renderChildView(this.header))
		// render body
		// filedrop + document children
		this.$el.append(template())
		this.renderFileDrop()

		if (_.isEmpty(this.model.attributes.children)) {
			this.$('.folder-contents').addClass('is-not-displayed')
		} else {
			this.$('.folder-contents').removeClass('is-not-displayed')
				.append(this.renderChildren())
		}


		this.secure()

		return this
	},

	renderFileDrop: function() {
		this.$('.file-drop').append(fileDrop({
			noDropMessage: window.FormData ? null : i18n.get('documents.upload.noDrop'),
			dropLabel: i18n.get('documents.upload.drop.document.1'),
			dropSubLabel: i18n.get('documents.upload.drop.document.2')
		}))

		this.fileDropOverlay = new FileDropOverlay({
			message: i18n.get('documents.upload.drop.document.1')
		})
		this.$el.append(this.fileDropOverlay.el)
		this.fileDropOverlay.render()
		this.fileDropOverlay.on('drop', e => this.showUploadForm(e))
	},

	onDragEnter: function(e) {
		this.fileDropOverlay.show()
	},

	onFileDropClick: function() {
		this.showUploadForm()
	},

	showUploadForm: function(e) {
		_.invoke(this.uploadForm, 'remove')
		delete this.uploadForm
		// #59512 the event will be provided if this was a drag and drop
		// and will be undefined if the user clicked the file drop
		let folderDrop = !_.isNil(e)

		this.uploadForm = new UploadForm({
			model: new File({
				relativeId: this.model.id,
				organizationId: globals.orgId,
				type: 'file'
			}),
			files: _.result(e, 'originalEvent.dataTransfer.files'),
			accept: config.allowedFileTypes,
			instructions: 'documents.upload.drop.document',
			maintainSelection: true,
			folderDrop
		})
		appDisplay.dialog(this.uploadForm)
		this.uploadForm.on('done', doc => {
			this._afterUpload(doc)
			this.trigger('done', doc)
		})
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
		// #32605 only show the file drop if the user has permission to modify documents
		if (!permissions.documents()) {
			this.$('.file-drop').addClass('is-not-displayed')
			this.fileDropOverlay.remove()
		}
	},

	// render direct child documents
	renderChildren: function() {
		this.children && this.children.remove()
		this.children = new Files({
			data: {
				children: this.model.attributes.children
			}
		})
		return this.renderChildView(this.children)
	},

	renderChildView: function(view) {
		this.childViews = this.childViews || []
		this.childViews.push(view)
		return view.render().$el.toggleClass('is-empty', _.isEmpty(view.documents))
	},

	fileDrop: function() {
		this.uploadForm = new UploadForm({
			instructions: 'documents.upload.drop.document',
			maintainSelection: true,
			document: function() {
				return new File({
					relativeId: this.model.id,
					organizationId: globals.orgId,
					type: 'file'
				})
			}.bind(this)
		}).on('done', doc => {
			this._afterUpload(doc)
		// When the file drop hides itself, hide it's container as well
		}).on('toggle:hidden', () => this.$('.file-drop-row').addClass('is-not-displayed'))
		return this.uploadForm
	},

	_afterUpload: function(doc) {
		var children = this.model.get('children') || []
		children.push(doc.attributes)
		this.model.set('children', children)
		this.renderChildren()
		this.render()
		// Calling spotlight() without the delay here
		// stops the style transition from happening #12843
		process.nextTick(() => spotlight(this.$('tr').last()))
	},

	editDomainObject: function(model) {
		if (this.model.id == model.id) {
			this.model.set('label', model.get('label'))
		}
		_.each(this.model.get('children'), function(child) {
			if (child.id == model.id) {
				child.label = model.get('label')
			}
		})
		this.render()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
		_.invokeMap(this.uploadForm, 'remove')
	},

	removeChildren: function() {
		_.invokeMap(this.childViews, 'remove')
	}

})

export default FolderOverview

FolderOverview.__filename__ = 'documents/documents-folder-overview.js'
